import React from 'react';
export function NewPageIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a1 1 0 011-1h7v3a3 3 0 003 3h3v2a1 1 0 102 0V9a1 1 0 00-.293-.707l-6-6A1 1 0 0014 2H6a3 3 0 00-3 3v14a3 3 0 003 3h6a1 1 0 100-2H6a1 1 0 01-1-1V5zm12.586 3L15 5.414V7a1 1 0 001 1h1.586zM13 17a1 1 0 011-1h2v-2a1 1 0 112 0v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 01-1-1z"
  }));
}